(function () {
  const LOTTIE_CDN =
    "https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js";

  function loadLottieScript() {
    if (window.lottie) return Promise.resolve();
    if (window.__lottieLoadingPromise) return window.__lottieLoadingPromise;

    window.__lottieLoadingPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = LOTTIE_CDN;
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error("Failed to load lottie-web"));
      document.head.appendChild(s);
    });

    return window.__lottieLoadingPromise;
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function initLottieInContainer(container) {
    const els = Array.from(container.querySelectorAll("[data-lottie]"));
    if (!els.length) return;

    loadLottieScript()
      .then(() => {
        els.forEach((el) => {
          if (el.__lottieInstance) return;

          const url = el.getAttribute("data-lottie-url");
          if (!url) return;

          const repeat = el.getAttribute("data-lottie-repeat") === "true";
          const repeatDelay = Number(el.getAttribute("data-lottie-repeat-delay") || 0);

          const shouldAutoplay = !prefersReducedMotion();

          const anim = window.lottie.loadAnimation({
            container: el,
            renderer: "svg",
            loop: false,
            autoplay: shouldAutoplay,
            path: url,
            rendererSettings: {
              progressiveLoad: true,
              preserveAspectRatio: "xMidYMid meet",
            },
          });

          el.__lottieInstance = anim;

          if (!shouldAutoplay) {
            anim.addEventListener("DOMLoaded", () => {
              anim.goToAndStop(0, true);
            });
            return;
          }

          if (repeat) {
            anim.addEventListener("complete", () => {
              window.setTimeout(() => {
                if (!el.isConnected || !el.__lottieInstance) return;
                anim.goToAndPlay(0, true);
              }, Math.max(0, repeatDelay) * 1000);
            });
          }
        });
      })
      .catch(() => {});
  }

  function destroyLottieInContainer(container) {
    const els = Array.from(container.querySelectorAll("[data-lottie]"));
    els.forEach((el) => {
      if (el.__lottieInstance) {
        try {
          el.__lottieInstance.destroy();
        } catch (e) {}
        el.__lottieInstance = null;
      }
      el.innerHTML = "";
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initLottieInContainer(document);
  });

  document.addEventListener("shopify:section:load", (e) => {
    if (e && e.target) initLottieInContainer(e.target);
  });

  document.addEventListener("shopify:section:unload", (e) => {
    if (e && e.target) destroyLottieInContainer(e.target);
  });
})();
